<div class="mat-calendar-timepicker">
  @if (todayDate) {
    <ngx-timepicker-field [defaultTime]="defaultTime" (timeChanged)="timeChanged($event)" [max]="maxDateTime" [controlOnly]="true"></ngx-timepicker-field>
  }
  @if (!todayDate) {
    <ngx-timepicker-field [defaultTime]="defaultTime" (timeChanged)="timeChanged($event)" [controlOnly]="true"></ngx-timepicker-field>
  }
</div>
